/**
 * The profile-name step: a signed-in person missing a first or last name is
 * asked for both before anything else, as iOS and Android do after a Google
 * sign-in that gave none. Pure, so it is tested in node.
 */

/** The step's title, wherever it is asked: over the app, or on the Join page. */
export const PROFILE_NAME_TITLE = 'Let’s set up your profile'

/** The most characters either name takes, as on the apps. */
export const PROFILE_NAME_MAX_LENGTH = 30

interface ProfileName {
	firstName?: string | null
	lastName?: string | null
}

/** Whether the person still has to give their name. Nothing is asked until the profile loads. */
export const needsProfileName = (user: ProfileName | undefined): boolean =>
	!!user && (!user.firstName?.trim() || !user.lastName?.trim())

/** The names to save, trimmed and capped, or null until both are filled in. */
export const profileNamePatch = (
	firstName: string,
	lastName: string,
): { firstName: string; lastName: string } | null => {
	const first = firstName.trim().slice(0, PROFILE_NAME_MAX_LENGTH)
	const last = lastName.trim().slice(0, PROFILE_NAME_MAX_LENGTH)
	return first && last ? { firstName: first, lastName: last } : null
}
